<template>
  <!-- <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"> -->
  <template v-if="loading">
    <SkeletonLoader v-for="n in 6" :key="n" width="100%" height="171px" />
  </template>

  <template v-else-if="isAdmin">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

      <div class="flex gap-4">
        <div v-if="selectedStatus === 'All' || selectedStatus === 'Not Started'"
          class="space-y-4 bg-primaryBg p-3 min-w-full">
          <div class="flex justify-between items-center">
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#E0921E] rounded-full"></div>
              On Hold - {{ onHoldProjectsCountAdmin }}
            </span>
            <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </p>
          </div>
          <div v-for="project in onHoldProjectsAdmin" :key="project.project_id" @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-5 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[15px] text-bodyText font-semibold">{{ project.project_name }}</h2>
            </div>

            <div class="flex items-center">
              <div class="relative w-[241px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-primaryDarkBg rounded-full"
                  :style="{ width: `${project.progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-6 overlap" />
              </div>
              <div class="flex items-center text-[14px] rounded-[8px] text-grayDark font-medium gap-2">
                <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
                {{ formatDate(project.end_date) }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedStatus === 'All' || selectedStatus === 'Active'"
          class="space-y-4 bg-primaryBg p-3 min-w-full">
          <div class="flex justify-between items-center">
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#E0921E] rounded-full"></div>
              Active - {{ activeProjectsCountAdmin }}
            </span>
            <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </p>
          </div>
          <div v-for="project in activeProjectsAdmin" :key="project.project_id" @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-5 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[15px] text-bodyText font-semibold">{{ project.project_name }}</h2>
            </div>

            <div class="flex items-center">
              <div class="relative w-[241px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-primaryDarkBg rounded-full"
                  :style="{ width: `${project.progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-6 overlap" />
              </div>
              <div class="flex items-center text-[14px] rounded-[8px] text-grayDark font-medium gap-2">
                <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
                {{ formatDate(project.end_date) }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedStatus === 'All' || selectedStatus === 'Completed'"
          class="space-y-4 bg-primaryBg p-3 min-w-full">
          <div class="flex justify-between items-center">
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#53D65A] rounded-full"></div>
              Completed - {{ completedProjectsCountAdmin }}
            </span>
            <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </p>
          </div>
          <div v-for="project in completedProjectsAdmin" :key="project.project_id"
            @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-5 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[15px] text-bodyText font-semibold">{{ project.project_name }}</h2>
            </div>

            <div class="flex items-center">
              <div class="relative w-[241px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-[#2F6DF7] rounded-full"
                  :style="{ width: `${project.progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-6 overlap" />
              </div>
              <div class="flex items-center text-[14px] rounded-[8px] text-grayDark font-medium gap-2">
                <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
                {{ formatDate(project.end_date) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </template>
  <template v-else-if="isTalent || isManager">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

      <div class="flex gap-4">
        <div v-if="selectedStatus === 'All' || selectedStatus === 'Not Started'"
          class="space-y-4 bg-primaryBg p-3 min-w-full">
          <div class="flex justify-between items-center">
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#E0921E] rounded-full"></div>
              On Hold - {{ onHoldProjectsCount }}
            </span>
            <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </p>
          </div>
          <div v-for="project in onHoldProjects" :key="project.project_id" @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-5 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[15px] text-bodyText font-semibold">{{ project.project_name }}</h2>
            </div>

            <div class="flex items-center">
              <div class="relative w-[241px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-primaryDarkBg rounded-full"
                  :style="{ width: `${project.progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-6 overlap" />
              </div>
              <div class="flex items-center text-[14px] rounded-[8px] text-grayDark font-medium gap-2">
                <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
                {{ formatDate(project.end_date) }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedStatus === 'All' || selectedStatus === 'Active'"
          class="space-y-4 bg-primaryBg p-3 min-w-full">
          <div class="flex justify-between items-center">
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#E0921E] rounded-full"></div>
              Active - {{ activeProjectsCount }}
            </span>
            <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </p>
          </div>
          <div v-for="project in activeProjects" :key="project.project_id" @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-5 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[15px] text-bodyText font-semibold">{{ project.project_name }}</h2>
            </div>

            <div class="flex items-center">
              <div class="relative w-[241px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-primaryDarkBg rounded-full"
                  :style="{ width: `${project.progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-6 overlap" />
              </div>
              <div class="flex items-center text-[14px] rounded-[8px] text-grayDark font-medium gap-2">
                <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
                {{ formatDate(project.end_date) }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedStatus === 'All' || selectedStatus === 'Completed'"
          class="space-y-4 bg-primaryBg p-3 min-w-full">
          <div class="flex justify-between items-center">
            <span class="flex items-center text-[14px] gap-2">
              <div class="w-2 h-2 bg-[#53D65A] rounded-full"></div>
              Completed - {{ completedProjectsCount }}
            </span>
            <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </p>
          </div>
          <div v-for="project in completedProjects" :key="project.project_id" @click="goToProject(project.project_id)"
            class="w-full border border-grayLight rounded-lg py-3 px-5 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
            <div class="flex justify-between w-full items-center">
              <h2 class="text-[15px] text-bodyText font-semibold">{{ project.project_name }}</h2>
            </div>

            <div class="flex items-center">
              <div class="relative w-[241px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
                <!-- Inner progress bar -->
                <div class="absolute top-0 left-0 h-full bg-[#2F6DF7] rounded-full"
                  :style="{ width: `${project.progress}%` }"></div>
              </div>
              <span class="ml-2 text-[12px] font-medium">{{ project.progress }}%</span>
            </div>

            <div class="flex justify-between w-full">
              <div class="flex -space-x-2">
                <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-6 overlap" />
                <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-6 overlap" />
              </div>
              <div class="flex items-center text-[14px] rounded-[8px] text-grayDark font-medium gap-2">
                <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
                {{ formatDate(project.end_date) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template v-else-if="isInvestor">
    <div class="px-6 space-y-4 border border-grayLight py-6 rounded-lg">
      <p>Projects</p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div v-for="project in rojects" :key="project.project_id" @click="goToProject(project.project_id)"
          class="w-full border border-grayLight rounded-lg py-3 px-3 space-y-4 mb-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray">
          <div class="flex justify-between w-full items-center">
            <div class="flex gap-2">
              <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-8 overlap" />
              <h2 class="text-[16px] text-bodyText font-semibold">{{ project.project_name }}</h2>
            </div>
            <div class="flex py-[6px] px-2 rounded-full bg-[#EAF3F5] space-x-2 items-center">
              <p class="text-[13px] text-[#348B9A]">
                {{ project.status || project.status }}
              </p>
            </div>
          </div>
          <p class="text-[10px] text-grayDark">{{ project.description }}</p>

          <div class="flex items-center">
            <div class="relative w-[100%] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden">
              <!-- Inner progress bar -->
              <div class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                :style="{ width: `${project.progress}%` }"></div>
            </div>
            <span v-if="project.progress" class="ml-2 text-[12px] font-medium">{{ project.progress }}%</span>
            <span v-else class="ml-2 text-[12px] font-medium">0%</span>

          </div>

          <div class="flex justify-between w-full">
            <div class="flex -space-x-2">
              <img src="@/assets/dashboard/team-img1.svg" alt="team" class="h-[22px] overlap" />
              <img src="@/assets/dashboard/team-img2.svg" alt="team" class="h-[22px] overlap" />
              <img src="@/assets/dashboard/team-img3.svg" alt="team" class="h-[22px] overlap" />
              <img src="@/assets/dashboard/team-img4.svg" alt="team" class="h-[22px] overlap" />
            </div>
            <p class="flex text-[11px] py-1 px-2 rounded-[4px] bg-[#EBEBEC] text-primaryDarkBg font-medium">View project
            </p>
          </div>
        </div>
      </div>
    </div>

  </template>
  <template v-else>
          Project not found.
  </template>

  <!-- </div>  -->


</template>

<script>
import apiClient from '@/axios'
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'KanbanGrid',
  components: {
    SkeletonLoader,
  },
  props: {
    projects: {
      type: Array,
      required: true,
    },
    investorProjects: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      user: {},
      loading: true,
      managedProjects: [],
      selectedStatus: 'All', // Initial status for showing all projects

    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isInvestor() {
      return this.$store.getters.isInvestor;
    },
    onHoldProjects() {
      return this.projects.filter(project => project.project_status === 'OnHold');
    },
    activeProjects() {
      return this.projects.filter(project => project.project_status === 'Active');
    },
    completedProjects() {
      return this.projects.filter(project => project.project_status === 'Completed');
    },
    onHoldProjectsCount() {
      return this.projects.filter(project => project.project_status === 'OnHold').length;
    },
    activeProjectsCount() {
      return this.projects.filter(project => project.project_status === 'Active').length;
    },
    completedProjectsCount() {
      return this.projects.filter(project => project.project_status === 'Completed').length;
    },

    // Admin
    onHoldProjectsAdmin() {
      return this.projects.filter(project => project.status === 'OnHold');
    },
    activeProjectsAdmin() {
      return this.projects.filter(project => project.status === 'Active');
    },
    completedProjectsAdmin() {
      return this.projects.filter(project => project.status === 'Completed');
    },
    onHoldProjectsCountAdmin() {
      return this.projects.filter(project => project.status === 'OnHold').length;
    },
    activeProjectsCountAdmin() {
      return this.projects.filter(project => project.status === 'Active').length;
    },
    completedProjectsCountAdmin() {
      return this.projects.filter(project => project.status === 'Completed').length;
    },
  },
  methods: {
    async fetchCurrentUser() {
      try {
        const response = await apiClient.post('/current_user');
        this.user = response.data.user;
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    },
    async fetchProjects() {
      try {
        // let response;

        // if (this.isManager) {
        //   response = await apiClient.get(`/web/manager/me`);
        //   const managerData = response.data.data;
        //   this.projects = managerData.projects || [];
        // } else if (this.isAdmin) {
        //   response = await apiClient.get('/web/projects_all');
        //   this.projects = response.data.data || [];
        // } else if (this.isTalent) {
        //   response = await apiClient.get('/web/talent/me');
        //   const talentData = response.data.data;
        //   this.projects = talentData.projects || [];
        // }
        //  else if (this.isInvestor) {
        //   response = await apiClient.get('/web/projects/Investor/all');
        //   this.projects = response.data.data || [];
        // }

        // this.filterProjectsByStatus('All');

      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        this.loading = false;
      }
    },
    created() {
      this.filteredProjects = this.projects; // Show all projects initially
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const month = date.getMonth() + 1; // Months are zero-based
      const day = date.getDate();
      return `${month}/${day}`;
    },
    filterProjectsByStatus(status) {
      // this.filteredProjects = this.projects.filter(project => project.status === status);
      if (status === 'All') {
        this.filteredProjects = this.projects;
      } else {
        this.filteredProjects = this.projects.filter(project => project.status === status);
      }
    },
    handleStatusChange(status) {
      this.selectedStatus = status;
    },
    goToProject(projectId) {
      this.$router.push({ name: 'ProjectDetails', params: { projectId } });
    },
  },
  created() {
    this.fetchCurrentUser();
    this.fetchProjects();
  },
};
</script>